import { atom } from "jotai";
import PublicationRecord from "models/view-models/publication-record";

const OfflinePublicationsAtom = atom<Array<PublicationRecord> | undefined>(
    undefined
);

export default OfflinePublicationsAtom;
